import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import FlowView from 'components/core/FlowView'
import { notify } from 'helpers'
import http from 'API/http'
import Select from 'react-select'
import moment from 'moment'

class OrderOverview extends FlowView {
  constructor (props) {
    super(props)
    this.state = {
      orders: [],
      stateFilter: '',
      loading: true
    }
  }
  componentDidMount () {
    this.getData()
  }
  async getData() {
    this.setState({loading: true})
    var err, res
    [err, res] = await http.get('2.4/orders', (this.state.stateFilter && {state: this.state.stateFilter}))
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({orders: res.data, loading: false})
  }
  fromOrderState(state) {
    switch (state) {
      case 'DONE_SUCCESS':
        return <span className='label orders-label label-success'><b>{state}</b></span>
        break;
      case 'RECEIVED':
        return <span className='label orders-label label-primary'><b>{state}</b></span>
        break;
      case 'IN_PROGRESS':
        return <span className='label orders-label label-warning'><b>{state}</b></span>
        break;
      case 'DONE_FAILED':
        return <span className='label orders-label label-danger'><b>{state}</b></span>
        break;
      default:
    }
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Orders' icon='fa-first-order' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='filter' title='Filter'>
            <div className="row">
              <div className='col-md-2 col-sm-4'>
                <span className='access-filter-name'>Filter by State</span>
              </div>
              <div className="col-md-10">
                <Select
                  searchable
                  labelKey='value'
                  valueKey='value'
                  clearable
                  value={this.state.stateFilter}
                  options={[{value: 'DONE_SUCCESS'}, {value: 'DONE_FAILED'}, {value: 'IN_PROGRESS'}, {value: 'RECEIVED'}]}
                  onChange={(state) => this.setState({stateFilter: (state ? state.value : '')}, this.getData)}
                />
              </div>
            </div>
          </StaticBox>
          <StaticBox cols={12} icon='first-order' title='Orders'>
            <FlowTable loading={this.state.loading} paginatable={20} data={
                this.state.orders.map(order => [
                  {onClick: e => (window.location.href = '/#/access/' + order.accessId)},
                  <a href={'/#/access/' + order.accessId} className='table-link'><i className='fa fa-folder-open-o' /></a>,
                  this.fromOrderState(order.state),
                  order.operation,
                  order.service,
                  moment(order.requestedDateTime).format('YYYY-MM-DD HH:mm:ss')
                ])}>
              <tr>
                <th className='buttons' />
                <th style={{'width': '120px'}}>State</th>
                <th>Operation</th>
                <th>Service</th>
                <th>Time</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
OrderOverview = connect(state => state.siteReducer)(OrderOverview)
export default OrderOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/orders/overview.js